import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 12 9.607",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9.607\" id=\"icon-list\">\r\n  <path id=\"icon-list_更多\" class=\"cls-1\" d=\"M16.125,113.68H26.893a.6.6,0,1,0,0-1.195H16.125a.6.6,0,1,0,0,1.195Zm10.768,2.987H16.125a.6.6,0,1,0,0,1.195H26.893a.6.6,0,1,0,0-1.195Zm0,4.231H16.125a.6.6,0,1,0,0,1.195H26.893a.6.6,0,1,0,0-1.195Zm0,0\" transform=\"translate(-15.509 -112.485)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol